import { JSX } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import AccountBillingPage from './AccountBillingPage';

export default function Routes(): JSX.Element {
  return (
    <Switch>
      <Route exact path="/account-and-billing">
        <AccountBillingPage />
      </Route>

      {/* Old standalone Invoices/Statements links (ID-13148, retired) land on the new page. */}
      <Route exact path={['/invoices', '/statements/invoices']}>
        <Redirect to="/account-and-billing" />
      </Route>
    </Switch>
  );
}
